const gopherInstalled = () => {
  return !!document.querySelector('#gopher-installed');
};

export const setInstalledFormInput = (form: any) => {
  const handleFormSubmit = () => {
    const input = form.querySelector('#gopher_installed');
    input.value = gopherInstalled();
    form.removeEventListener('submit', handleFormSubmit);
  };
  form.addEventListener('submit', handleFormSubmit);
};


export default gopherInstalled;
